export const formatCellValue = (value: any): string => {
  if (value === undefined || value === null) return "-";
  // If the original value is a string, return as-is (preserves block labels etc.)
  if (typeof value === "string") return value;
  const num = Number(value);
  // If value is numeric, format it.
  if (!isNaN(num)) {
    return num.toFixed(2);
  }
  return value.toString();
};
